// extracted by mini-css-extract-plugin
module.exports = {"close":"EtykietyPopup_close__hGVd7"};